var module = angular.module('octopusApp.infrastructure');

module.directive('bindFiles', function(){
  return {
    scope: {
      files: '=bindFiles'
    },
    link: function (scope, element) {
      element.bind('change', function(){
        // Currently a bit of a hack while the uploader is shaken out
        scope.$apply(function() { scope.files = element[0].files; });
      });
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/bind_files.js
// module id = 6713892537668736
// module chunks = 1